// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__2hbQP","perfil":"style_perfil__3P4xr"};